import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpHandlingService } from 'src/app/api/services/http-handling.service';
import { SERVER_API_URL } from 'src/app/common/types/app.constants';
import { CompetitionResult } from 'src/app/common/types/competition-results';
import { SeasonResult } from 'src/app/common/types/season-results.interface';

@Injectable()
export class SeasonSpeedTrialResultsTableService {
  constructor(
    private httpHandlingService: HttpHandlingService,
    private http: HttpClient
  ) {}

  /**
   * function for getting all season results by season id
   * @param type for evaluation of desired round
   */
  getSeasonSpeedTrialResultsBySeasonType(
    type: string
  ): Observable<SeasonResult[]> {
    return this.http.get<SeasonResult[]>(
      SERVER_API_URL + '/api/season-results/season/speed-trial/' + type,
      { headers: this.httpHandlingService.authorizationHeaders() }
    );
  }
}
